import React from 'react';
import PropTypes from 'prop-types';

export default function FeatureChecklist({ fmgr, className = '', loadForest, setOpen }) {
    const { features, setRequested } = fmgr;
    const rows = [
        { key: 'sharedDrives', title: 'Спільні диски' },
        { key: 'sharedWithMe', title: 'Відкриті для мене' },
    ];

    const close = () => setOpen(false);

    // універсальний хендлер: підтримує sync/async setRequested
    const onToggle = async (key, checked) => {
        try {
            const maybePromise = setRequested(key, checked);
            if (maybePromise && typeof maybePromise.then === 'function') {
                await maybePromise;
            }
        } finally {
            loadForest?.(key, checked);
            // якщо хочеш автозакриття після будь-якої дії — розкоментуй:
            // close();
        }
    };

    return (
        <div
            className={`
                fixed bottom-3 right-0           /* фіксована панель внизу праворуч */
                w-[90%] max-w-xs                 /* компактна ширина */
                rounded-l-xl                     /* округлення лише лівого краю */
                p-3 shadow-lg z-50               /* відступи, тінь, поверх інших */
                bg-white dark:bg-neutral-900     /* світла/темна тема */

                md:static                        /* звичайний потік документа */
                border bg-white  shadow-2xl
                md:w-auto md:max-w-md            /* нормальна ширина */
                md:rounded-xl                    /* повне округлення */
                
                ${className || ''}               /* додаткові класи, якщо передані */
            `}
        >
            {/* Хрестик у правому верхньому куті */}
            <button
                type="button"
                onClick={close}
                className="absolute right-3 top-3 md:right-4 md:top-4 inline-flex h-7 w-7 items-center justify-center rounded-md border text-sm hover:bg-gray-50 dark:hover:bg-neutral-800"
                aria-label="Закрити меню"
                title="Закрити меню"
            >
                ✕
            </button>

            <h3 className="font-semibold mb-2 pr-8">Замовити роботу з розділами</h3>

            <ul className="space-y-2">
                {rows.map((r) => {
                    const s = features[r.key] || {};
                    return (
                        <li key={r.key} className="flex items-center justify-between gap-3">
                            <label className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    checked={!!s.requested}
                                    onChange={(e) => onToggle(r.key, e.target.checked)}
                                />
                                <span>{r.title}</span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

FeatureChecklist.propTypes = {
    fmgr: PropTypes.shape({
        features: PropTypes.object.isRequired,
        setRequested: PropTypes.func.isRequired,
    }).isRequired,
    loadForest: PropTypes.func,
    className: PropTypes.string,
    setOpen: PropTypes.func.isRequired,
};
